export const en = {
    adaptive: 'Adaptive',
    create: 'Use as template'
};
